import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../Partials/Image/index";

const Footer = () => {
  return (
    <div>
      <footer id="footer">
        <div className="footer-top">
          <div className="container-2">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <h6>Social</h6>
                <ul>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"images/instagram-1.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"/images/instagram-2.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"/images/instagram-3.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"/images/instagram-2.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"/images/instagram-3.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/p/Bke6PHBHNaH/?taken-by=thinkoutsidegardens"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        className={"img-fluid"}
                        image={"/images/instagram-3.jpg"}
                      />
                    </Link>
                  </li>
                </ul>
                <Link
                  to="https://www.instagram.com/thinkoutsidegardens/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  @thinkoutsidegardens
                </Link>
              </div>
              <div className="col-sm-12 col-md-4">
                <h6>Shop</h6>
                <div className="product-footer">
                  <Image
                    className={"w-100"}
                    image={"/images/product-footer.jpg"}
                  />
                </div>
                <Link to="/shop" className="footer-link text-uppercase">
                  Shop Products
                </Link>
              </div>
              <div className="col-sm-12 col-md-4">
                <h6>Projects</h6>
                <ul>
                  <li>
                    <Link to="/projects/palm-beach">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/palm-beach-thumb.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects/balmain">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/balmain-thumb.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects/haberfield">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/haberfield2-thumb.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects/roselle">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/roselle-thumb.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects/bondi">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/bondi-thumb.jpg"}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects/mosman">
                      <Image
                        className={"img-fluid"}
                        image={"/images/projects/mosman-thumb.jpg"}
                      />
                    </Link>
                  </li>
                </ul>
                <Link to="/project-list" className="footer-link text-uppercase">
                  View All Projects
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-12 col-lg-5">
              <p>
                <span>Think Outside Gardens</span>
                <Link
                  to="https://www.instagram.com/thinkoutsidegardens/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </Link>
                <Link to="tel:+0293807957">(02) 9380 7957</Link>
                <Link to="imagine@thinkoutsidegardens.com.au">
                  imagine@thinkoutsidegardens.com.au
                </Link>
              </p>
            </div>
            <div className="col-md-12 col-lg-7 text-right">
              <p>
                <span>&nbsp;</span> © Think Outside Gardens. All rights
                reserved.
                <Link to="/">Terms &amp; Conditions</Link>
                <Link to="/">Privacy Policy</Link>
                <Link
                  to="http://www.squadink.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Site by Squad Ink
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
